import React from "react";

type Props = {
  name: 'arrow-right' | 'arrow-down' | 'zoom' | 'love' | 'qr' | 'file' | 'card' | 'card-list' | 'home' | 'home-light' | 'patient' | 'patient-light' | 'my' | 'my-light'
}

const LazyIcon: React.FC<Props> = ({ name })=> {
  return (
    <img src={ require(`../../assets/icons/${name}.svg`).default } alt={name}/>
  )
}

export default LazyIcon